import { useFetcher } from "~/hooks/useFetcher";
import { FILE_BROWSER_API } from "~/lib/fileBrowserApi";

export interface ExternalBucket {
  bucket_name: string;
  description: string;
}

/**
 * Fetches the list of external S3 buckets the current user has access to.
 * The backend handles filtering the buckets based on the user's permissions.
 */
const useExternalBuckets = () => {
  return useFetcher<ExternalBucket[]>(`${FILE_BROWSER_API}/external-buckets`);
};

export default useExternalBuckets;
